import { connect } from 'react-redux';
import { getRadioOptions } from 'src/reducers/selectOptions';
import { withModal } from 'jbc-front/components/CommonModal';
import BankItemSection from '../components/BankItemSection';

const mapStateToProps = state => ({
  depositTypes: getRadioOptions(state, 'depositTypes')
});

export default connect(mapStateToProps)(withModal(BankItemSection));
